import { AccessControlPermission, AccessControlRoleAdmin, AccessControlStaffUser } from '@admin/schema';

export const roleIdsForUser = (
  user: Pick<AccessControlStaffUser, 'roles' | 'explicitRoleIds'>,
  roles: AccessControlRoleAdmin[],
): string[] => {
  const fromJobRoles = roles.filter((role) => user.roles.includes(role.name)).map((role) => role.id);
  return Array.from(new Set([...user.explicitRoleIds, ...fromJobRoles]));
};

export const rolesWithPermission = (permissionId: string, roles: AccessControlRoleAdmin[]) =>
  roles.filter((role) => role.permissionIds.includes(permissionId));

export const usersWithPermission = (
  permissionId: string,
  roles: AccessControlRoleAdmin[],
  users: AccessControlStaffUser[],
) => {
  const grantingRoleIds = new Set(rolesWithPermission(permissionId, roles).map((role) => role.id));

  return users
    .map((user) => {
      const effectiveRoleIds = roleIdsForUser(user, roles);
      const grantingRoles = roles.filter((role) => grantingRoleIds.has(role.id) && effectiveRoleIds.includes(role.id));
      return { user, grantingRoles };
    })
    .filter(({ grantingRoles }) => grantingRoles.length > 0);
};

export const roleGrantCountByPermissionId = (roles: AccessControlRoleAdmin[]) => {
  const counts = new Map<string, number>();

  roles.forEach((role) => {
    role.permissionIds.forEach((permissionId) => {
      counts.set(permissionId, (counts.get(permissionId) ?? 0) + 1);
    });
  });

  return counts;
};

export const permissionLabel = (permission: Pick<AccessControlPermission, 'resource' | 'action'>) =>
  `${permission.resource}:${permission.action}`;
